const role = {
    ADMIN: 'UsersAdmins',
    PARTNER: 'UsersPartners',
    ACCOUNT: 'UsersAccounts',
    EXTERNAL: 'UsersExternals',
    DEVICES: 'UsersDevices'
}

export default Object.freeze(role)